module.exports = __webpack_public_path__ + "media/app/assets/classes/rogue-37eb5647dda525be51bbaad6e7ac2d82.jpg";